import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'boi-date-input',
  templateUrl: './date-input.component.html',
  styleUrls: ['./date-input.component.scss']
})
export class DateInputComponent {
  @Input() public isDisabled: boolean;
  @Input() set date(date: Date) {
    if (date) {
      const convertedDate = new Date(date);
      this.day = convertedDate.getDate();
      this.month = convertedDate.getMonth() + 1;
      this.year = convertedDate.getFullYear();
    } else if (this.day && this.month && this.year) {
      this.day = undefined;
      this.month = undefined;
      this.year = undefined;
    }
  }
  @Output() public readonly dateChange: EventEmitter<Date> = new EventEmitter<Date>();

  public day: number;
  public month: number;
  public year: number;

  private updateDayMaxValue(): void {
    let maxDayValue = 31;
    if (this.month && this.year) {
      maxDayValue = this.getNumberOfDaysInMonth(this.year, this.month);
    }

    if (this.day < 1 || this.day > maxDayValue) {
      this.day = undefined;
    }
  }

  private getNumberOfDaysInMonth(year: number, month: number): number {
    return new Date(year, month, 0).getDate();
  }

  public updateDay(): void {
    this.updateDayMaxValue();
    this.updateDate();
  }

  public updateMonth(): void {
    this.updateDayMaxValue();
    if (this.month < 1 || this.month > 12) {
      this.month = undefined;
    }
    this.updateDate();
  }

  public updateYear(): void {
    this.updateDayMaxValue();
    if (this.year < 1900 || this.year > 3000) {
      this.year = undefined;
    }
    this.updateDate();
  }

  private updateDate(): void {
    const date =
      this.day && this.month && this.year ? new Date(Date.UTC(this.year, this.month - 1, this.day)) : undefined;
    if (date) {
      this.dateChange.emit(date);
    }

    if (!this.day && !this.month && !this.year) {
      this.dateChange.emit(undefined);
    }
  }

  limitInputLength(event: any, fieldMaxLength: number): void {
    const isSelected = event.target.selectionEnd - event.target.selectionStart > 0;
    if (event.target.value.length >= fieldMaxLength && !isSelected) {
      event.preventDefault();
    }
  }
}
